import * as z from "zod";
import type { TFunction } from "i18next";

import {
  isValidDecimalStringInput,
  normalizeDecimalStringForApi,
} from "./decimalString";

/** Required decimal string: accepts comma or dot in input; output always uses dot. */
export const requiredApiDecimalString = (
  t: TFunction,
  requiredKey: string,
  invalidKey: string,
) =>
  z
    .string()
    .trim()
    .min(1, t(requiredKey))
    .refine(isValidDecimalStringInput, t(invalidKey))
    .transform(normalizeDecimalStringForApi);

/** Optional decimal string: empty/null passes; when filled, must be a valid decimal. */
export const optionalApiDecimalString = (t: TFunction, invalidKey: string) =>
  z.preprocess(
    (value) => {
      if (value == null || value === "") {
        return null;
      }
      const trimmed = String(value).trim();
      return trimmed === "" ? null : trimmed;
    },
    z
      .string()
      .nullable()
      .optional()
      .refine(
        (value) => value == null || isValidDecimalStringInput(value),
        t(invalidKey),
      )
      .transform((value) =>
        value == null ? null : normalizeDecimalStringForApi(value),
      ),
  );
